
import { Checkbox } from 'primereact/checkbox';
import React, {useEffect, useState} from 'react';
import { formatDate } from '../../constants/DateUtil/DateUtil';
import { checkPackageSubscriptionOffer } from '../../services/PaymentOfferManagement/CheckPackageSubscriptionOffer';
import { getStoreLocalData } from '../../utils/localStorage';

const PackageSubscriptionOfferDefault = ({
  storeCustomerId,
  storeId,
  storeUserId,
  grandTotal,
  onChecked,
  enabledApplySubscriptionWithPackage,
  enabledAutoApplySubscriptionWithPackage,
  cartPackageData,
  enabledAmountRoundOff,
}) => {

  const { storeLocalData } = getStoreLocalData();
  const [selectedItem, setSelectedItem] = useState([]);
  const [selectedItemValue, setSelectedItemValue] = useState(null);
  const [showHide, setShowHide] = useState(false);

  const handleItemPress = () => {
    setShowHide(showHide => !showHide);
  };

  const [subscriptionPackageOfferData, setSubscriptionPackageOfferData] =
    useState([]);

  // const fetchSubscriptionPackageOffer = packageSubscriptionData => {
  //   checkPackageSubscriptionOffer(
  //     storeId,
  //     storeCustomerId,
  //     packageSubscriptionData,
  //   )
  //     .then(response => {
  //       if (!response.data.error) {
  //         const res = response.data;
  //         const ResNew = res.map(item => ({
  //           id: item?.packageOfferSubscriber?.id,
  //           value: item.discount,
  //           expireDate: item?.packageOfferSubscriber?.validTo,
  //           packagePercentage: item?.packageOfferSubscriber?.brandPackageOffer?.value,
  //           packageName:item?.packageOfferSubscriber?.brandPackageOffer?.name
  //         }));
  //         setSubscriptionPackageOfferData(ResNew);
  //         // Resend selected item info when grandTotal changes
  //           if (selectedItem.length > 0) {
  //             const selectedItemData = ResNew.find(
  //               item => item.id === selectedItem[0]
  //             );
          
  //             if (selectedItemData) {
  //               onChecked({
  //                 selectedItemId: selectedItemData.id,
  //                 selectedItemValue: selectedItemData.value
  //               });
  //             }
  //           }
  //       }
  //     })
  //     .catch(err => {
  //       console.error('Error:', err);
  //     });
  // };

  // useEffect(() => {
  //   const packageSubscriptionData = {
  //     grandTotal: Math.round(grandTotal),
  //     storeCustomerId: storeCustomerId,
  //   };
  //   fetchSubscriptionPackageOffer(packageSubscriptionData);
  // }, [grandTotal]);

  useEffect(() => {
    const fetchData = async () => {
      const packageSubscriptionData = {
        grandTotal: Number(Number(grandTotal).toFixed(enabledAmountRoundOff)),
        storeCustomerId: storeCustomerId,
      };
  
      try {
        const response = await checkPackageSubscriptionOffer(
          storeId,
          storeCustomerId,
          packageSubscriptionData
        );
  
        if (!response.data.error) {
          const res = response.data;
          const ResNew = res.map(item => ({
            id: item?.packageOfferSubscriber?.id,
            value: item.discount,
            expireDate: item?.packageOfferSubscriber?.validTo,
            packagePercentage: item?.packageOfferSubscriber?.brandPackageOffer?.value,
            packageName: item?.packageOfferSubscriber?.brandPackageOffer?.name
          }));
          setSubscriptionPackageOfferData(ResNew);
  
          // Resend selected item info when grandTotal changes
          if (selectedItem.length > 0) {
            const selectedItemData = ResNew.find(
              item => item.id === selectedItem[0]
            );
  
            if (selectedItemData) {
              onChecked({
                selectedItemId: selectedItemData.id,
                selectedItemValue: selectedItemData.value
              });
            }
          }
        }
      } catch (err) {
        console.error('Error:', err);
      }
    };
  
    fetchData();
  }, [grandTotal]);
  
  
  const showPackageSubscriptionMessage = enabledApplySubscriptionWithPackage && cartPackageData?.length > 0 ? true : false;

const handleStatusToggle = item => {
  let updatedItems;

  // Check if the item is already selected
  if (selectedItem.includes(item.id)) {
    // If selected, remove it from the list
    updatedItems = selectedItem.filter(id => id !== item.id);
  } else {
    // If not selected, add it to the list
    updatedItems = [item.id];
  }

  // Update the selected items array
  setSelectedItem(updatedItems);

  // Pass the last selected item to onChecked as a single value
  const lastSelectedItem =
    updatedItems.length > 0 ? updatedItems[updatedItems.length - 1] : null;

    const lastSelectedItemValue =
    updatedItems.length > 0 ? item.value : null;

  onChecked({
    selectedItemId: lastSelectedItem,
    selectedItemValue: lastSelectedItemValue
  });

};
  return (
    subscriptionPackageOfferData?.length > 0 && (
      <div
      className="flex-1 shadow-2 px-3 mb-2"
      style={{
        backgroundColor: "#F6FAFF",
      }}
    >
        <div className={
          "flex flex-1 justify-content-between mx-2 py-2 cursor-pointer"
        }
          onClick={() => handleItemPress()}>
          <div className="flex justify-content-start align-items-center flex-1 ">
            <img
              src={'Laundy_App_Icons_Gifs/SettingIcons/gift.png'}
              resizeMode="cover"
              style={{
              width: 20,
              height: 20,
            }}
            />
            <p className=" text-lg font-medium capitalize ml-2">
              Package Subscription Offer {showPackageSubscriptionMessage && !enabledAutoApplySubscriptionWithPackage &&  "(* Package Item also added in cart)"}
            </p>
          </div>
          <div >
          {!showHide ? (
            <i
              className="pi pi-angle-down"
              style={{ fontSize: "25px", cursor: "pointer", color: "#777" }}
            ></i>
          ) : (
            <i
              className="pi pi-angle-up"
              style={{ fontSize: "25px", cursor: "pointer", color: "#777" }}
            ></i>
          )}
            
          </div>
        </div>
        <div ></div>

        {showHide && (
          <div
          className=" border-top-2"
          style={{
            borderTopColor: "#C1C9D3",
          }}
        >
            <div className="mt-3 pb-3">
              {subscriptionPackageOfferData.map(item => (
                <div key={item.id}
                      className=" flex my-1 mx-1 border-round-md shadow-4"
                      style={{
                        borderRadius: 5,
                        backgroundImage:
                          "radial-gradient(circle at left top, #FF5F6D, #FFC371)",
                        flex: 1,
                      }}
                    >
                  <div
                    className="flex-row flex justify-content-between align-items-center py-1 px-2">
                    <p className=" text-lg text-white font-medium capitalize">
                      Discount {storeLocalData?.currencySymbol} {item.value} | {(item.packagePercentage) + "%"}
                    </p>
                    <p className=" text-lg text-white font-medium capitalize">
                      {/* Expiry - {formatDate(item.expireDate)} */}
                      {item.packageName}
                    </p>
                    <Checkbox
                      checked={selectedItem.includes(item.id)}
                      color={
                        selectedItem.includes(item.id) ? '#00A3FF' : '#fff'
                      }
                      onClick={() => handleStatusToggle(item)}
                    ></Checkbox>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    )
  );
};

export default PackageSubscriptionOfferDefault;
